var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isReady
    ? _c(
        "div",
        { staticClass: "content animate-panel", attrs: { id: "home" } },
        [
          _c("top-banner", { attrs: { images: _vm.topBanner } }),
          _vm._v(" "),
          _c("section", { staticClass: "home-card" }, [
            _c("div", { staticClass: "section-header-row" }, [
              _c("div", { staticClass: "section-heading" }, [
                _c("i", { staticClass: "fa fa-bar-chart home-section-icon" }),
                _vm._v(" "),
                _c("span", { staticClass: "section-title" }, [
                  _vm._v("本日の販売状況")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "section-date" }, [
                  _vm._v(_vm._s(_vm.todayLabel))
                ])
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "section-link-btn",
                  on: {
                    click: function($event) {
                      _vm.handleClickViewAnalysis()
                    }
                  }
                },
                [
                  _vm._v("詳しく分析する "),
                  _c("i", { staticClass: "fa fa-angle-right" })
                ]
              )
            ]),
            _vm._v(" "),
            _vm.amountsData.length > 0
              ? _c("div", { staticClass: "sales-grid" }, [
                  _c("div", { staticClass: "metric" }, [
                    _c("div", { staticClass: "metric-top" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("div", [
                        _c("div", { staticClass: "metric-label" }, [
                          _vm._v("本日の売上金額")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "metric-value" }, [
                          _vm._v(
                            _vm._s(_vm.formatNumber(_vm.amountsData[0].value))
                          ),
                          _c("span", { staticClass: "metric-unit" }, [
                            _vm._v(_vm._s(_vm.amountsData[0].unit))
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "metric-note" }, [
                      _vm.amountsRate !== null
                        ? _c(
                            "span",
                            {
                              class:
                                _vm.amountsRate >= 0 ? "note-up" : "note-down"
                            },
                            [
                              _c("i", {
                                class:
                                  _vm.amountsRate >= 0
                                    ? "fa fa-caret-up"
                                    : "fa fa-caret-down"
                              }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.amountsRate >= 0 ? "+" : "") +
                                  _vm._s(_vm.amountsRate) +
                                  "%\n            "
                              )
                            ]
                          )
                        : _c("span", { staticClass: "note-neutral" }, [
                            _vm._v("―")
                          ]),
                      _vm._v(
                        "\n            （前日 " +
                          _vm._s(
                            _vm.formatNumber(
                              _vm.amountsData[1] ? _vm.amountsData[1].value : 0
                            )
                          ) +
                          _vm._s(_vm.amountsData[0].unit) +
                          "）\n          "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "metric" }, [
                    _c("div", { staticClass: "metric-top" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("div", [
                        _c("div", { staticClass: "metric-label" }, [
                          _vm._v("本日の注文件数")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "metric-value" }, [
                          _vm._v(
                            _vm._s(_vm.formatNumber(_vm.ordersData[0].value))
                          ),
                          _c("span", { staticClass: "metric-unit" }, [
                            _vm._v(_vm._s(_vm.ordersData[0].unit))
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "metric-note" }, [
                      _vm.ordersRate !== null
                        ? _c(
                            "span",
                            {
                              class:
                                _vm.ordersRate >= 0 ? "note-up" : "note-down"
                            },
                            [
                              _c("i", {
                                class:
                                  _vm.ordersRate >= 0
                                    ? "fa fa-caret-up"
                                    : "fa fa-caret-down"
                              }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.ordersRate >= 0 ? "+" : "") +
                                  _vm._s(_vm.ordersRate) +
                                  "%\n            "
                              )
                            ]
                          )
                        : _c("span", { staticClass: "note-neutral" }, [
                            _vm._v("―")
                          ]),
                      _vm._v(
                        "\n            （前日 " +
                          _vm._s(
                            _vm.formatNumber(
                              _vm.ordersData[1] ? _vm.ordersData[1].value : 0
                            )
                          ) +
                          _vm._s(_vm.ordersData[0].unit) +
                          "）\n          "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "metric" }, [
                    _c("div", { staticClass: "metric-top" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("div", [
                        _c("div", { staticClass: "metric-label" }, [
                          _vm._v("本日の販売個数")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "metric-value" }, [
                          _vm._v(
                            _vm._s(_vm.formatNumber(_vm.salesData[0].value))
                          ),
                          _c("span", { staticClass: "metric-unit" }, [
                            _vm._v(_vm._s(_vm.salesData[0].unit))
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "metric-note" }, [
                      _vm.salesRate !== null
                        ? _c(
                            "span",
                            {
                              class:
                                _vm.salesRate >= 0 ? "note-up" : "note-down"
                            },
                            [
                              _c("i", {
                                class:
                                  _vm.salesRate >= 0
                                    ? "fa fa-caret-up"
                                    : "fa fa-caret-down"
                              }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.salesRate >= 0 ? "+" : "") +
                                  _vm._s(_vm.salesRate) +
                                  "%\n            "
                              )
                            ]
                          )
                        : _c("span", { staticClass: "note-neutral" }, [
                            _vm._v("―")
                          ]),
                      _vm._v(
                        "\n            （前日 " +
                          _vm._s(
                            _vm.formatNumber(
                              _vm.salesData[1] ? _vm.salesData[1].value : 0
                            )
                          ) +
                          _vm._s(_vm.salesData[0].unit) +
                          "）\n          "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "metric" }, [
                    _c("div", { staticClass: "metric-top" }, [
                      _vm._m(3),
                      _vm._v(" "),
                      _c("div", [
                        _c("div", { staticClass: "metric-label" }, [
                          _vm._v("本日の返品個数")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "metric-value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.formatNumber(
                                _vm.returnsData.length > 0
                                  ? _vm.returnsData[0].value
                                  : 0
                              )
                            )
                          ),
                          _c("span", { staticClass: "metric-unit" }, [
                            _vm._v(
                              _vm._s(
                                _vm.returnsData.length > 0
                                  ? _vm.returnsData[0].unit
                                  : "個"
                              )
                            )
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.returnsData.length > 0
                      ? _c("div", { staticClass: "metric-note" }, [
                          _vm.returnsRate !== null
                            ? _c(
                                "span",
                                {
                                  class:
                                    _vm.returnsRate <= 0
                                      ? "note-up"
                                      : "note-down"
                                },
                                [
                                  _c("i", {
                                    class:
                                      _vm.returnsRate >= 0
                                        ? "fa fa-caret-up"
                                        : "fa fa-caret-down"
                                  }),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.returnsRate >= 0 ? "+" : "") +
                                      _vm._s(_vm.returnsRate) +
                                      "%\n            "
                                  )
                                ]
                              )
                            : _c("span", { staticClass: "note-neutral" }, [
                                _vm._v("―")
                              ]),
                          _vm._v(
                            "\n            （前日 " +
                              _vm._s(
                                _vm.formatNumber(
                                  _vm.returnsData[1]
                                    ? _vm.returnsData[1].value
                                    : 0
                                )
                              ) +
                              _vm._s(_vm.returnsData[0].unit) +
                              "）\n          "
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "sales-chart" },
                    [
                      _c("kpi-sparkline", {
                        attrs: {
                          data: _vm.amountsData,
                          "orders-data": _vm.ordersData,
                          "sales-data": _vm.salesData,
                          "returns-data": _vm.returnsData
                        }
                      })
                    ],
                    1
                  )
                ])
              : _c("div", { staticClass: "text-center" }, [
                  _c("i", { staticClass: "fa fa-spinner fa-spin" })
                ])
          ]),
          _vm._v(" "),
          _c("section", { staticClass: "home-card" }, [
            _c("div", { staticClass: "section-header-row" }, [
              _c("div", { staticClass: "section-heading-block" }, [
                _c("div", { staticClass: "section-title" }, [
                  _c("img", {
                    staticClass: "section-logo",
                    attrs: {
                      src:
                        "https://image-yoshino.sakura.ne.jp/monster/SaleMonAgent.png",
                      alt: "セルモンエージェント"
                    }
                  }),
                  _vm._v(
                    "\n            セルモンエージェントからのおすすめ\n            "
                  ),
                  _vm.isBasicPlan || _vm.isPremiumTrial
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-premium-cta",
                          on: {
                            click: function($event) {
                              _vm.$router.push("/setting/plan-info")
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-diamond" }),
                          _vm._v(" プレミアムに登録する "),
                          _c("i", { staticClass: "fa fa-chevron-circle-right" })
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "section-subtitle" }, [
                  _vm._v(
                    "あなたのデータから、今やるべきアクションを見つけました。"
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "section-link-btn",
                  on: {
                    click: function($event) {
                      _vm.$router.push("/salemon-agent")
                    }
                  }
                },
                [
                  _vm._v("エージェント画面を開く "),
                  _c("i", { staticClass: "fa fa-angle-right" })
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "agent-grid" },
              [
                _vm.userInfo.hasReturnRecommend
                  ? _c(
                      "article",
                      { staticClass: "agent-card agent-card--red" },
                      [
                        _vm._m(4),
                        _vm._v(" "),
                        _c("div", { staticClass: "agent-head" }, [
                          _vm._m(5),
                          _vm._v(" "),
                          _c("div", [
                            _vm._m(6),
                            _vm._v(" "),
                            _c("div", { staticClass: "agent-value" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formatNumber(_vm.userInfo.totalFbaFee)
                                )
                              ),
                              _c("span", { staticClass: "agent-unit" }, [
                                _vm._v("円")
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "agent-btn agent-btn--red",
                            on: {
                              click: function($event) {
                                _vm.$router.push(
                                  "/salemon-agent/long-term-stock"
                                )
                              }
                            }
                          },
                          [
                            _vm._v("対象商品を確認する "),
                            _c("i", { staticClass: "fa fa-angle-right" })
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isBasicPlan && !_vm.isPremiumTrial
                  ? [
                      _vm.userInfo.countFbaProductSales > 0
                        ? _c(
                            "article",
                            { staticClass: "agent-card agent-card--green" },
                            [
                              _vm._m(7),
                              _vm._v(" "),
                              _c("div", { staticClass: "agent-head" }, [
                                _vm._m(8),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._m(9),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "agent-value" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatNumber(
                                          _vm.userInfo.countFbaProductSales
                                        )
                                      )
                                    ),
                                    _c("span", { staticClass: "agent-unit" }, [
                                      _vm._v("件")
                                    ])
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "agent-btn agent-btn--green",
                                  on: {
                                    click: function($event) {
                                      _vm.$router.push(
                                        "/salemon-agent/fba-product-sales"
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v("対象商品を確認する "),
                                  _c("i", { staticClass: "fa fa-angle-right" })
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userInfo.countSalemonRecommend > 0
                        ? _c(
                            "article",
                            { staticClass: "agent-card agent-card--purple" },
                            [
                              _vm._m(10),
                              _vm._v(" "),
                              _c("div", { staticClass: "agent-head" }, [
                                _vm._m(11),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._m(12),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "agent-value" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatNumber(
                                          _vm.userInfo.countSalemonRecommend
                                        )
                                      )
                                    ),
                                    _c("span", { staticClass: "agent-unit" }, [
                                      _vm._v("件")
                                    ])
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "agent-btn agent-btn--purple",
                                  on: {
                                    click: function($event) {
                                      _vm.$router.push(
                                        "/salemon-agent/sales-expansion"
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v("対象商品を確認する "),
                                  _c("i", { staticClass: "fa fa-angle-right" })
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userInfo.countSelmonProductsAvailable > 0
                        ? _c(
                            "article",
                            { staticClass: "agent-card agent-card--blue" },
                            [
                              _vm._m(13),
                              _vm._v(" "),
                              _c("div", { staticClass: "agent-head" }, [
                                _vm._m(14),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._m(15),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "agent-value" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatNumber(
                                          _vm.userInfo
                                            .countSelmonProductsAvailable
                                        )
                                      )
                                    ),
                                    _c("span", { staticClass: "agent-unit" }, [
                                      _vm._v("件")
                                    ])
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "agent-btn agent-btn--blue",
                                  on: {
                                    click: function($event) {
                                      _vm.$router.push(
                                        "/salemon-agent/product-available"
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v("対象商品を確認する "),
                                  _c("i", { staticClass: "fa fa-angle-right" })
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  : _vm.isBasicPlan
                  ? [
                      _vm._m(16),
                      _vm._v(" "),
                      _vm._m(17),
                      _vm._v(" "),
                      _vm._m(18)
                    ]
                  : [
                      _vm._m(19),
                      _vm._v(" "),
                      _vm._m(20),
                      _vm._v(" "),
                      _vm._m(21)
                    ]
              ],
              2
            )
          ]),
          _vm._v(" "),
          _vm.warehousesData
            ? _c("section", { staticClass: "home-card" }, [
                _c("div", { staticClass: "section-header-row" }, [
                  _vm._m(22),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "section-link-btn",
                      on: {
                        click: function($event) {
                          _vm.handleClickJoinPremium()
                        }
                      }
                    },
                    [
                      _vm._v("プラン・設定を確認する "),
                      _c("i", { staticClass: "fa fa-angle-right" })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "usage-grid" }, [
                  _c("div", { staticClass: "usage-block" }, [
                    _c("div", { staticClass: "usage-label" }, [
                      _vm._v("ご利用プラン")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: [
                          "usage-value",
                          _vm.isBasicPlan ? "" : "usage-premium"
                        ]
                      },
                      [
                        _vm._v(
                          "\n            " + _vm._s(_vm.plan) + "\n            "
                        ),
                        _vm.isPremiumTrial
                          ? _c("span", { staticClass: "text-size-14" }, [
                              _vm._v("(トライアル)")
                            ])
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", [
                      _vm.isBasicPlan || _vm.isPremiumTrial
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-premium-cta",
                              on: {
                                click: function($event) {
                                  _vm.$router.push("/setting/plan-info")
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "fa fa-diamond" }),
                              _vm._v(" プレミアムに登録する "),
                              _c("i", {
                                staticClass: "fa fa-chevron-circle-right"
                              })
                            ]
                          )
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "usage-block" }, [
                    _c("div", { staticClass: "usage-label" }, [
                      _vm._v("登録商品数 / 出品可能数")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "usage-inline" }, [
                      _c("strong", { staticClass: "usage-inline-num" }, [
                        _vm._v(
                          _vm._s(
                            _vm.formatNumber(_vm.warehousesData.offerCount)
                          )
                        )
                      ]),
                      _c("span", [_vm._v("件")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "usage-inline-sep" }, [
                        _vm._v("/")
                      ]),
                      _vm._v(" "),
                      _c(
                        "strong",
                        {
                          staticClass: "usage-inline-num usage-inline-num--sub"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.formatNumber(
                                _vm.warehousesData.maxListingAmount
                              )
                            )
                          )
                        ]
                      ),
                      _c("span", [_vm._v("件")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "usage-bar" }, [
                      _c("div", {
                        staticClass: "usage-bar-fill",
                        style: { width: _vm.listingUsageRatio + "%" }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "usage-link",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            _vm.handleClickAddAvailableQuantity()
                          }
                        }
                      },
                      [
                        _vm._v("出品可能数を追加する "),
                        _c("i", { staticClass: "fa fa-angle-right" })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "usage-block" }, [
                    _c("div", { staticClass: "usage-label" }, [
                      _vm._v("審査状況")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "usage-status-row" }, [
                      _c("span", [
                        _vm._v("審査中 "),
                        _c("strong", { staticClass: "usage-status" }, [
                          _vm._v(_vm._s(_vm.warehousesData.review))
                        ]),
                        _vm._v("件")
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("出品中 "),
                        _c(
                          "strong",
                          { staticClass: "usage-status usage-active" },
                          [_vm._v(_vm._s(_vm.warehousesData.sale))]
                        ),
                        _vm._v("件")
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("審査NG "),
                        _c("strong", { staticClass: "usage-status usage-ng" }, [
                          _vm._v(_vm._s(_vm.warehousesData.reject))
                        ]),
                        _vm._v("件")
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "usage-link",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            _vm.handleClickRequestReconsideration()
                          }
                        }
                      },
                      [
                        _vm._v("審査状況を確認する "),
                        _c("i", { staticClass: "fa fa-angle-right" })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "usage-block usage-block--logi" }, [
                    _vm._m(23),
                    _vm._v(" "),
                    _c("div", { staticClass: "usage-divider" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "usage-stockcrew" }, [
                      _c("img", {
                        staticClass: "stockcrew-logo",
                        attrs: {
                          src: _vm.iconUrls["salmonSc"],
                          alt: "STOCKCREW"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", [
                        _c("div", { staticClass: "usage-label" }, [
                          _vm._v("STOCKCREW倉庫")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            class: [
                              "usage-value",
                              _vm.warehouseScUsed
                                ? "usage-active"
                                : "usage-inactive"
                            ]
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.warehouseScUsed ? "利用中" : "未利用"
                                ) +
                                "\n              "
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.warehouseScUsed
                      ? _c(
                          "a",
                          {
                            staticClass: "usage-link",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                _vm.handleClickOpenWarehouse("salmonSc")
                              }
                            }
                          },
                          [
                            _vm._v("STOCKCREW倉庫を開く "),
                            _c("i", { staticClass: "fa fa-angle-right" })
                          ]
                        )
                      : _c(
                          "a",
                          {
                            staticClass: "usage-link",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                _vm.handleClickGetStarted("salmonSc")
                              }
                            }
                          },
                          [
                            _vm._v("利用を開始する "),
                            _c("i", { staticClass: "fa fa-angle-right" })
                          ]
                        )
                  ])
                ])
              ])
            : _c("section", { staticClass: "home-card" }, [
                _vm._m(24),
                _vm._v(" "),
                _vm._m(25)
              ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-grid" }, [
            _c("section", { staticClass: "home-card info-card" }, [
              _vm._m(26),
              _vm._v(" "),
              _vm.notices.length > 0
                ? _c(
                    "div",
                    { staticClass: "info-list" },
                    _vm._l(_vm.notices.slice(0, 5), function(notice, i) {
                      return _c(
                        "div",
                        {
                          key: i,
                          staticClass: "info-item",
                          on: {
                            click: function($event) {
                              _vm.handleViewNotice(notice)
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "info-date" }, [
                            _vm._v(_vm._s(notice.date))
                          ]),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "info-link",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.replaceHTMLSellerInfo(notice.title)
                              )
                            }
                          })
                        ]
                      )
                    }),
                    0
                  )
                : _vm.notices.length === 0
                ? _c("div", { staticClass: "info-empty" }, [
                    _vm._v("現在お知らせはありません")
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("section", { staticClass: "home-card info-card" }, [
              _vm._m(27),
              _vm._v(" "),
              _vm.eventData && _vm.eventData.length > 0
                ? _c(
                    "div",
                    { staticClass: "info-list" },
                    _vm._l(_vm.eventData, function(item, i) {
                      return _c(
                        "a",
                        {
                          key: i,
                          staticClass: "info-item",
                          attrs: { href: item.destUrl, target: "_blank" },
                          on: {
                            click: function($event) {
                              !item.destUrl && $event.preventDefault()
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "info-link" }, [
                            _vm._v(_vm._s(item.content))
                          ]),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "fa fa-external-link info-ext"
                          })
                        ]
                      )
                    }),
                    0
                  )
                : !_vm.eventData
                ? _c("div", { staticClass: "text-center" }, [
                    _c("i", { staticClass: "fa fa-spinner fa-spin" })
                  ])
                : _c("div", { staticClass: "info-empty" }, [
                    _vm._v("現在イベント情報はありません")
                  ])
            ]),
            _vm._v(" "),
            _c("section", { staticClass: "home-card info-card" }, [
              _vm._m(28),
              _vm._v(" "),
              _vm.manualData && _vm.manualData.length > 0
                ? _c(
                    "div",
                    { staticClass: "info-list" },
                    _vm._l(_vm.manualData, function(item, i) {
                      return _c(
                        "a",
                        {
                          key: i,
                          staticClass: "info-item",
                          attrs: { href: item.destUrl, target: "_blank" },
                          on: {
                            click: function($event) {
                              !item.destUrl && $event.preventDefault()
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "info-link" }, [
                            _vm._v(_vm._s(item.content))
                          ])
                        ]
                      )
                    }),
                    0
                  )
                : !_vm.manualData
                ? _c("div", { staticClass: "text-center" }, [
                    _c("i", { staticClass: "fa fa-spinner fa-spin" })
                  ])
                : _c("div", { staticClass: "info-empty" }, [
                    _vm._v("現在マニュアルはありません")
                  ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "home-bottom-banners" },
            _vm._l(_vm.bottomBanner, function(item, i) {
              return _c(
                "a",
                {
                  key: i,
                  staticClass: "bottom-banner-card",
                  attrs: { href: item.destUrl, target: "_blank" },
                  on: {
                    click: function($event) {
                      !item.destUrl && $event.preventDefault()
                    }
                  }
                },
                [
                  _c("img", {
                    staticClass: "bottom-banner-img",
                    attrs: { src: item.content }
                  })
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.isShowModalAmazonExpiration && _vm.amazonExpirationContext.length
            ? _c("modal-amazon-expiration", {
                attrs: { amazonExpirationContext: _vm.amazonExpirationContext }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "metric-ico" }, [
      _c("i", { staticClass: "fa fa-jpy" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "metric-ico" }, [
      _c("i", { staticClass: "fa fa-line-chart" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "metric-ico" }, [
      _c("i", { staticClass: "fa fa-shopping-cart" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "metric-ico" }, [
      _c("i", { staticClass: "fa fa-reply" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "agent-top" }, [
      _c("span", { staticClass: "agent-tag agent-tag--red" }, [
        _vm._v("FBA長期在庫")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "agent-icon" }, [
      _c("i", { staticClass: "fa fa-exclamation-triangle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "agent-title" }, [
      _vm._v("FBAで無駄な手数料が"),
      _c("br"),
      _vm._v("発生しています")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "agent-top" }, [
      _c("span", { staticClass: "agent-tag agent-tag--green" }, [
        _vm._v("FBA納品推奨")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "agent-icon" }, [
      _c("i", { staticClass: "fa fa-truck" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "agent-title" }, [
      _vm._v("商品を納品して、"),
      _c("br"),
      _vm._v("適切な在庫レベルを維持しましょう")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "agent-top" }, [
      _c("span", { staticClass: "agent-tag agent-tag--purple" }, [
        _vm._v("販売機会拡大")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "agent-icon" }, [
      _c("i", { staticClass: "fa fa-line-chart" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "agent-title" }, [
      _vm._v("販売機会を逃している商品が"),
      _c("br"),
      _vm._v("あります")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "agent-top" }, [
      _c("span", { staticClass: "agent-tag agent-tag--blue" }, [
        _vm._v("セルモンへの出品")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "agent-icon" }, [
      _c("i", { staticClass: "fa fa-plus-circle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "agent-title" }, [
      _vm._v("今すぐ出品できる商品が"),
      _c("br"),
      _vm._v("あります")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "agent-card agent-card--green" }, [
      _c("div", { staticClass: "agent-top" }, [
        _c("span", { staticClass: "agent-tag agent-tag--green" }, [
          _vm._v("FBA納品推奨")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "agent-head" }, [
        _c("div", { staticClass: "agent-icon" }, [
          _c("i", { staticClass: "fa fa-truck" })
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "agent-title" }, [
          _vm._v("売れ行きを予測し、適切なFBA納品数をご提案します！")
        ])
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "agent-premium-badge" }, [
        _c("i", { staticClass: "fa fa-lock" }),
        _vm._v(" プレミアム限定")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "agent-card agent-card--purple" }, [
      _c("div", { staticClass: "agent-top" }, [
        _c("span", { staticClass: "agent-tag agent-tag--purple" }, [
          _vm._v("販売機会拡大")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "agent-head" }, [
        _c("div", { staticClass: "agent-icon" }, [
          _c("i", { staticClass: "fa fa-line-chart" })
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "agent-title" }, [
          _vm._v("見逃しているかもしれない販売機会についてお知らせします！")
        ])
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "agent-premium-badge" }, [
        _c("i", { staticClass: "fa fa-lock" }),
        _vm._v(" プレミアム限定")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "agent-card agent-card--blue" }, [
      _c("div", { staticClass: "agent-top" }, [
        _c("span", { staticClass: "agent-tag agent-tag--blue" }, [
          _vm._v("セルモンへの出品")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "agent-head" }, [
        _c("div", { staticClass: "agent-icon" }, [
          _c("i", { staticClass: "fa fa-plus-circle" })
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "agent-title" }, [
          _vm._v("売上アップにつながる商品をお知らせ ワンクリックで出品！")
        ])
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "agent-premium-badge" }, [
        _c("i", { staticClass: "fa fa-lock" }),
        _vm._v(" プレミアム限定")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "agent-card agent-card--green" }, [
      _c("div", { staticClass: "agent-top" }, [
        _c("span", { staticClass: "agent-tag agent-tag--green" }, [
          _vm._v("FBA納品推奨")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "agent-head" }, [
        _c("div", { staticClass: "agent-icon" }, [
          _c("i", { staticClass: "fa fa-truck" })
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "agent-title" }, [
          _vm._v("売れ行きを予測し、適切なFBA納品数をご提案します!")
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "agent-caption" }, [
        _vm._v("※こちらの機能はプレミアムプラン専用となります。")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "agent-card agent-card--purple" }, [
      _c("div", { staticClass: "agent-top" }, [
        _c("span", { staticClass: "agent-tag agent-tag--purple" }, [
          _vm._v("販売機会拡大")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "agent-head" }, [
        _c("div", { staticClass: "agent-icon" }, [
          _c("i", { staticClass: "fa fa-line-chart" })
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "agent-title" }, [
          _vm._v("見逃しているかもしれない販売機会についてお知らせします！")
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "agent-caption" }, [
        _vm._v("※こちらの機能はプレミアムプラン専用となります。")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "agent-card agent-card--blue" }, [
      _c("div", { staticClass: "agent-top" }, [
        _c("span", { staticClass: "agent-tag agent-tag--blue" }, [
          _vm._v("セルモンへの出品")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "agent-head" }, [
        _c("div", { staticClass: "agent-icon" }, [
          _c("i", { staticClass: "fa fa-plus-circle" })
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "agent-title" }, [
          _vm._v("売上アップにつながる商品をお知らせ "),
          _c("i", {
            staticClass: "fa fa-envelope-o",
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v(" ワンクリックで出品！")
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "agent-caption" }, [
        _vm._v("※こちらの機能はプレミアムプラン専用となります。")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-heading" }, [
      _c("span", { staticClass: "section-title" }, [
        _c("img", {
          staticClass: "section-logo section-logo--sm",
          attrs: {
            src:
              "https://salemonster.info/static/dists/img/ic_SaleMonster24.png",
            alt: "セールモンスター"
          }
        }),
        _vm._v(" ご利用状況")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "usage-block-head" }, [
      _c("img", {
        staticClass: "w-30",
        attrs: {
          src: "https://image-yoshino.sakura.ne.jp/monster/SaleMonLogi.png"
        }
      }),
      _vm._v("\n            セルモンロジ\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-heading" }, [
      _c("span", { staticClass: "section-title" }, [_vm._v("ご利用状況")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "text-center", staticStyle: { padding: "20px 0" } },
      [_c("i", { staticClass: "fa fa-spinner fa-spin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header-row" }, [
      _c("div", { staticClass: "section-heading" }, [
        _c("i", { staticClass: "fa fa-bell-o home-section-icon" }),
        _c("span", { staticClass: "section-title" }, [_vm._v("お知らせ")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header-row" }, [
      _c("div", { staticClass: "section-heading" }, [
        _c("i", { staticClass: "fa fa-calendar-o home-section-icon" }),
        _c("span", { staticClass: "section-title" }, [_vm._v("イベント情報")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header-row" }, [
      _c("div", { staticClass: "section-heading" }, [
        _c("i", { staticClass: "fa fa-book home-section-icon" }),
        _c("span", { staticClass: "section-title" }, [_vm._v("マニュアル")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fb8a7244", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb8a7244","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/home/Home.vue
// module id = null
// module chunks = 